<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import { throttle } from 'lodash-es';
import VisitGroupAddonAccommodations from '../../../components/ski/visitgroup/VisitGroupAddonAccommodations';

export default {
  name: 'VisitGroupAddons',
  components: {
    VisitGroupAddonAccommodations,
  },
  data() {
    return {
      headers: [
        { text: 'Id', class: 'px-2', value: 'id' },
        { text: 'Addon Name', class: 'px-2', value: 'addonName' },
        { text: 'Mandatory', class: 'px-2', value: 'isMandatory' },
        { text: 'Used', class: 'px-2 text-xs-center', value: 'accommodationCount' },
        { text: 'Active', class: 'px-2', value: 'isActive' },
        { text: 'Aligned Extra Id', class: 'px-2', value: 'alignedExtraId' },
      ],
      pagination: {
        rowsPerPage: 20,
        sortBy: 'addonName',
      },
      paginationRowsPerPage: [
        20,
        50,
        { text: 'All', value: -1 },
      ],
    };
  },
  computed: {
    ...mapState({
      xmlChannels: state => state.visitgroup.xmlChannels,
      addon: state => state.visitgroup.addons.addon,
      addons: state => state.visitgroup.addons.items,
      loading: state => state.visitgroup.addons.loading,
      xmlChannelId: state => state.visitgroup.addons.xmlChannelId,
      update: state => state.visitgroup.addons.update,
    }),
    ...mapGetters({
      filteredAddons: 'visitgroup/getAddons',
    }),
  },
  methods: {
    ...mapActions({
      search: 'visitgroup/searchAddons',
      setXmlChannel: 'visitgroup/setXmlChannel',
      getAddons: 'visitgroup/getAddonsByXmlChannelId',
      updateAddon: 'visitgroup/updateAddon',
      showAddonAccommodationModal: 'visitgroup/showAddonAccommodationModal',
    }),
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    changeAddon(addon) {
      const updateAddon = {
        id: addon.id,
        alignedExtraId: addon.alignedExtraId,
        isActive: addon.isActive,
      };
      this.updateAddon(updateAddon);
    },
    throttleSearch: throttle(function input(search) {
      this.search(search);
    }, 250, { leading: false }),
  },
};
</script>

<template>
  <v-card>
    <v-container fluid>
      <v-layout row>
        <v-flex xs3>
          <v-select
            :value="xmlChannels.xmlChannel"
            :items="xmlChannels.items"
            :loading="xmlChannels.loading"
            :disabled="xmlChannels.loading"
            :error-messages="xmlChannels.error ? $t('skistar.resorts.error') : undefined"
            :error="!!xmlChannels.error"
            label="Destinations"
            item-value="id"
            item-text="webservice"
            @input="setXmlChannel"
          />
          <visit-group-addon-accommodations
            v-if="addon.showProductNames"
            :id="addon.id"
            :addon-name="addon.addonName"
            :accommodations="addon.xmlChannelProducts"
            :show="addon.showProductNames"
          />
        </v-flex>
        <v-flex xs6 pl-4>
          <v-text-field
            append-icon="search"
            label="Search"
            clearable
            @input="throttleSearch"
          />
        </v-flex>
      </v-layout>
      <v-layout row>
        <v-flex xs12>
          <v-data-table
            :items="filteredAddons"
            :headers="headers"
            :loading="loading"
            :pagination.sync="pagination"
            :rows-per-page-items="paginationRowsPerPage"
            no-results-text="No addons"
            class="print"
            item-key="id"
            must-sort
          >
            <template v-slot:headers="props">
              <tr>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="['column sortable',
                           pagination.descending ? 'desc' : 'asc',
                           header.value === pagination.sortBy ? 'active' : '',
                           header.class ? header.class : '',
                           header.align ? 'text-xs-' + header.align : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  {{ header.text }}
                  <v-icon small>arrow_upward</v-icon>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="px-1">{{ props.item.id }}</td>
                <td class="px-2">{{ props.item.addonName }}</td>
                <td class="px-2">{{ props.item.isMandatory }}</td>
                <td class="px-2 text-xs-center">
                  <v-btn
                    color="primary"
                    round
                    small
                    @click="showAddonAccommodationModal(props.item)"
                  >
                    {{ props.item.xmlChannelProducts.length }}
                  </v-btn>
                </td>
                <td class="px-2 pt-3">
                  <v-checkbox
                    v-model="props.item.isActive"
                    :disabled="props.item.isMandatory"
                    :loading="update.inProgressItems[props.item.id]"
                    @change="changeAddon(props.item)"
                  />
                </td>
                <td class="px-2">
                  <v-text-field
                    v-model="props.item.alignedExtraId"
                    :loading="update.inProgressItems[props.item.id]"
                    @change="changeAddon(props.item)"
                  />
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
  </v-card>
</template>




// WEBPACK FOOTER //
// src/pages/ski/visitgroup/VisitGroupAddons.vue